import {
	Tooth,
	ToothRestorationCrownBase,
	ToothRestorationCrownType,
	ToothRestorationType,
	ToothState,
} from '../../../graphql/graphql';

export default function getToothState(tooth?: Tooth) {
	if (tooth?.missing) {
		return ToothState.Missing;
	}

	if (tooth?.toBeExtracted) {
		return ToothState.ToBeExtracted;
	}

	if (tooth?.restoration?.crownBase === ToothRestorationCrownBase.Implant) {
		return ToothState.Implant;
	}

	if (tooth?.restoration?.crownType === ToothRestorationCrownType.Pontic) {
		return ToothState.Crown;
	}

	if (tooth?.restoration?.type === ToothRestorationType.Crown) {
		return ToothState.SingleCrown;
	}

	return ToothState.Normal;
}
